import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_LOCATIONS](state, data) {
    state.allLocations = data
  },
}
